import React from 'react';
import PropTypes from 'prop-types';

const UiDismissLargePath = ({ fill }) => {
  return (
    <path
      fill={fill}
      d="M17.414 16l7.513-7.513a.375.375 0 0 0 0-.53l-.884-.884a.375.375 0 0 0-.53 0L16 14.586 8.487 7.073a.375.375 0 0 0-.53 0l-.884.884a.375.375 0 0 0 0 .53L14.586 16l-7.513 7.513a.375.375 0 0 0 0 .53l.884.884a.375.375 0 0 0 .53 0L16 17.414l7.513 7.513a.375.375 0 0 0 .53 0l.884-.884a.375.375 0 0 0 0-.53L17.414 16z"
    />
  );
};

UiDismissLargePath.propTypes = {
  fill: PropTypes.string,
};

export default UiDismissLargePath;



// WEBPACK FOOTER //
// ./src/icon/svgs/ui-controls/ui-dismiss-large.jsx